const typesByLanguage = {
  java: [
    'String',
    'Long',
    'Integer',
    'Double',
    'Boolean',
    'UUID',
    'LocalDate',
    'LocalDateTime',
  ],
  python: [
    'str',
    'int',
    'float',
    'bool',
    'UUID',
    'date',
    'datetime',
  ],
};

export default typesByLanguage;
